// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "-legacy." + {"153":"22b3084e","260":"cb9e9014","668":"4e16ff96","762":"9408d11d"}[chunkId] + ".js";
};